import { ApolloProvider } from "@apollo/client";
import { Checkmark, Close, Notification } from "@carbon/icons-react";
import { CacheProvider } from "@emotion/react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import { SnackbarProvider, closeSnackbar } from "notistack";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import "./App.scss";
import AuthAppGateway from "./components/AuthGateway";
import { useApolloClient } from "./hooks/useApolloClient";
import useTheme from "./hooks/useTheme";
import "./i18n";
import createTheme from "./theme";
import createEmotionCache from "./utils/createEmotionCache";

const clientSideEmotionCache = createEmotionCache();
require("moment/locale/de");

function App({ emotionCache = clientSideEmotionCache }) {
  const { theme } = useTheme();
  const { t } = useTranslation();
  moment.locale(t("locale"));

  return (
    <CacheProvider value={emotionCache}>
      <ApolloProvider client={useApolloClient()}>
        <HelmetProvider>
          <Helmet
            titleTemplate={t("supplierPortal")}
            defaultTitle={t("supplierPortal")}
          />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MuiThemeProvider theme={createTheme(theme)}>
              <SnackbarProvider
                iconVariant={{
                  success: <Checkmark />,
                  error: <Notification />,
                  warning: <Notification />,
                  info: <Notification />,
                }}
                action={(snackbarId) => {
                  return (
                    <Close
                      className="snackbar-close"
                      onClick={() => closeSnackbar(snackbarId)}
                    />
                  );
                }}
                autoHideDuration={6000}
              >
                <AuthAppGateway />
              </SnackbarProvider>
            </MuiThemeProvider>
          </LocalizationProvider>
        </HelmetProvider>
      </ApolloProvider>
    </CacheProvider>
  );
}

export default App;
